import { TipoUsuario } from 'user/models/Usuario';

export const IMPERSONATION_ACTOR_TYPES = ['OPERADOR', 'BANCO'] as const satisfies readonly TipoUsuario[];

export type ImpersonationActorType = (typeof IMPERSONATION_ACTOR_TYPES)[number];

export const IMPERSONACION_MENU_FUNCTIONALITY = 'IMPERSONACION_MENU' as const;
